export default "__VITE_ASSET__BqqN$5Fc__"